import React from 'react'
import PropTypes from 'prop-types'
import { reduxForm } from 'redux-form'
import Fields from './fields'
import validate from './validator'

const Form = ({ form, spaceOptions = [] }) => <Fields form={form} spaceOptions={spaceOptions} />

Form.propTypes = {
  form: PropTypes.string.isRequired,
  spaceOptions: PropTypes.array,
}

export default reduxForm({ validate, enableReinitialize: true })(Form)
